import React from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Provider configurations
const providerConfig = {
  google: {
    name: 'Google',
    authUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
    scope: 'openid email profile',
    color: 'bg-white hover:bg-gray-50 text-gray-700 border-2 border-gray-300',
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
      </svg>
    ),
  },
  apple: {
    name: 'Apple',
    authUrl: 'https://appleid.apple.com/auth/authorize',
    clientId: process.env.REACT_APP_APPLE_CLIENT_ID || '',
    scope: 'name email',
    responseMode: 'form_post',
    color: 'bg-black hover:bg-gray-900 text-white border-2 border-black',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
      </svg>
    ),
  },
  facebook: {
    name: 'Facebook',
    authUrl: 'https://www.facebook.com/v18.0/dialog/oauth',
    clientId: process.env.REACT_APP_FACEBOOK_APP_ID || '',
    scope: 'public_profile email',
    color: 'bg-[#1877F2] hover:bg-[#0e62cc] text-white border-2 border-[#1877F2]',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
  instagram: {
    name: 'Instagram',
    authUrl: 'https://api.instagram.com/oauth/authorize',
    clientId: process.env.REACT_APP_INSTAGRAM_APP_ID || '',
    scope: 'user_profile',
    color: 'bg-gradient-to-tr from-[#FCAF45] via-[#E1306C] to-[#833AB4] hover:opacity-90 text-white border-2 border-transparent',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
  },
};

const SocialLoginButton = ({ provider, variant = 'default' }) => {
  const config = providerConfig[provider];

  if (!config) {
    console.error(`Unknown provider: ${provider}`);
    return null;
  }

  // Hide button entirely if the OAuth client ID is not configured
  if (!config.clientId) return null;

  const handleLogin = () => {
    // Generate state for CSRF protection
    const state = Math.random().toString(36).substring(7);
    sessionStorage.setItem('oauth_state', state);
    sessionStorage.setItem('oauth_provider', provider);

    // Build redirect URI (callback URL for backend)
    const redirectUri = `${BACKEND_URL}/api/auth/callback/${provider}`;
    sessionStorage.setItem('oauth_redirect_uri', redirectUri);

    // Build authorization URL
    const params = new URLSearchParams({
      client_id: config.clientId,
      redirect_uri: redirectUri,
      scope: config.scope,
      response_type: 'code',
      state: state,
    });

    // Add response_mode for Apple
    if (provider === 'apple' && config.responseMode) {
      params.append('response_mode', config.responseMode);
    }

    const authUrl = `${config.authUrl}?${params.toString()}`;

    // Redirect to provider's OAuth page
    window.location.href = authUrl;
  };

  // Compact variant (icon only, for multiple buttons side-by-side)
  if (variant === 'compact') {
    return (
      <button
        onClick={handleLogin}
        className={`
          w-12 h-12 rounded-xl flex items-center justify-center transition-all
          ${config.color}
          shadow-sm hover:shadow-md
        `}
        title={`Sign in with ${config.name}`}
      >
        {config.icon}
      </button>
    );
  }

  // Default variant (full button with text)
  return (
    <button
      onClick={handleLogin}
      className={`
        w-full flex items-center justify-center gap-3 px-4 py-3 rounded-xl
        font-semibold transition-all
        ${config.color}
        shadow-sm hover:shadow-md
      `}
    >
      {config.icon}
      <span>Continue with {config.name}</span>
    </button>
  );
};

export default SocialLoginButton;
